import { cx } from "@linaria/core";

import { useAudio } from "@pm2/compat";

import * as styles from "./_player.style";
import { Description } from "./atom.description";
import { LeftGraphic } from "./atom.left-graphic";
import { Controls } from "./molecule.controls";
import { AudioModel } from "@courses-pm2/api";
import { description } from "./atom.description.style";

type Props = {
  className?: string;
  src: string;
  title: string;
  imageSrc?: string;

  isScrambled: boolean;
  caption: AudioModel["caption"];
};

export function AudioPlayer(props: Props) {
  const audio = useAudio({
    src: props.src,
    autoplay: false,
    notifier: {
      notify: (options) => {
        console.warn(options.body);
      },
    },
  });

  return (
    <div className={cx(styles.wrapper, props.className)}>
      <LeftGraphic
        imageSrc={props.imageSrc}
        audio={audio}
        disabled={props.isScrambled}
      />

      <div className={styles.content}>
        <div className={styles.text}>
          {props.title && (
            <h4 className={styles.title} data-scrambled={props.isScrambled}>
              {props.title}
            </h4>
          )}

          {audio.didError ? (
            <span className={description}>
              Der opstod en fejl under indlæsningen af lydfilen.
            </span>
          ) : (
            <Description
              caption={props.caption}
              title={props.title}
              isScrambled={props.isScrambled}
            />
          )}
        </div>

        <Controls audio={audio} disabled={props.isScrambled} />
      </div>
    </div>
  );
}
